import { CubicHorizontal } from '@antv/g6'

export class CustomCubic extends CubicHorizontal {
  // static defaultStyleProps: Partial<CubicHorizontalStyleProps> = {
  //   curvePosition: [0.5, 0.5],
  //   curveOffset: [10, 0],
  //   lineDashOffset: -50,
  // }

  // constructor(options: DisplayObjectConfig<CubicHorizontalStyleProps>) {
  //   console.log('CubicHorizontal', options)

  //   super(mergeOptions({ style: CubicHorizontal.defaultStyleProps }, options))
  // }

  // getMarkerStyle(attributes) {
  //   return { r: 5, fill: '#c3d5f9', offsetPath: this.shapeMap.key, ...subStyleProps(attributes, 'marker') }
  // }

  // onCreate() {
  //   const shape = this.shapeMap.key
  //   shape.animate([{ lineDashOffset: -20 }, { lineDashOffset: 0 }], {
  //     duration: 500,
  //     iterations: Infinity,
  //   })
  // }

  public animate(_keyframes: Keyframe[], _options) {
    const nodeData = this.context.graph.getNodeData(this.config.style.targetNode)
    const isRight = nodeData.position === 'right'
    const rightKeyframes: Keyframe[] = [{ lineDashOffset: 20 }, { lineDashOffset: 0 }]
    const leftKeyframes: Keyframe[] = [{ lineDashOffset: 0 }, { lineDashOffset: 20 }]

    const animation = super.animate(isRight ? rightKeyframes : leftKeyframes, {
      duration: 500,
      iterations: Infinity,
    })

    if (animation) {
      animation.onframe = () => this.onframe()
      animation.finished.then(() => this.onframe())
    }

    return animation
  }
}
